/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Cli_Formats_LabelInputs */

const en_hub_cli_formats_label = /** @type {(inputs: Hub_Cli_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export formats`)
};

const id_hub_cli_formats_label = /** @type {(inputs: Hub_Cli_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format ekspor`)
};

/**
* | output |
* | --- |
* | "Export formats" |
*
* @param {Hub_Cli_Formats_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_cli_formats_label = /** @type {((inputs?: Hub_Cli_Formats_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Cli_Formats_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_cli_formats_label(inputs)
	return en_hub_cli_formats_label(inputs)
});